import {
  HiSparkles,
  HiStar,
  HiCalendarDays,
  HiOutlineSparkles,
} from 'react-icons/hi2';
import { FaMedal } from 'react-icons/fa6';

import { ProfileBadge } from 'utils/profileBadges';

import * as styled from './styles';

const ICONS: Record<
  ProfileBadge['icon'],
  React.ComponentType<{ size?: number }>
> = {
  star: HiStar,
  sparkles: HiSparkles,
  calendar: HiCalendarDays,
  ribbon: FaMedal,
};

const ICON_FALLBACK = HiOutlineSparkles;
const ICON_SIZE = 13;

type Props = {
  badge: ProfileBadge;
};

export const TrustBadge = ({ badge }: Props) => {
  const Icon = ICONS[badge.icon] ?? ICON_FALLBACK;
  return (
    <styled.Pill $tone={badge.tone}>
      <Icon size={ICON_SIZE} />
      <styled.Label>{badge.label}</styled.Label>
    </styled.Pill>
  );
};
